import React from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { RCTooltip } from 'components/RCTooltip'

import './index.scss'

const SimpleCard = observer(({ className = '', title, tooltipText, filterText, children }) => {
  return (
    <div className={`simple-card-container ${className}`}>
      <div className="simple-card-title-container">
        {title && (
          <h4 className="simple-card-title">
            {title}
            {tooltipText && (
              <RCTooltip direction="right" tooltipMessage={tooltipText}>
                <div className="centered-icon">
                  <Icon fill="var(--primary_light1)" icon="questionMark" width={24} height={24} />
                </div>
              </RCTooltip>
            )}
          </h4>
        )}
        {filterText && <div className="simple-card-filter-text">{filterText}</div>}
      </div>
      {children}
    </div>
  )
})

SimpleCard.propTypes = {}

SimpleCard.defaultProps = {}

SimpleCard.displayName = 'SimpleCard'

export default SimpleCard
